"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/borrow-block-reason.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fborrow-block-reason.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowBlockReasonToJSON = exports.borrowBlockReasonFromJSON = exports.BorrowBlockReason = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
/**
 * Reason for blocking a user from using a borrowing product
 */
var BorrowBlockReason;
(function (BorrowBlockReason) {
    BorrowBlockReason["INVALID_BLOCK_REASON"] = "INVALID_BLOCK_REASON";
    /**
     * PAST_DUE_PAYMENT - User is past due on a payment
     */
    BorrowBlockReason["PAST_DUE_PAYMENT"] = "PAST_DUE_PAYMENT";
    /**
     * FAILED_REPAYMENT - User have failed to pay us after grace period
     * for a past due payment
     */
    BorrowBlockReason["FAILED_REPAYMENT"] = "FAILED_REPAYMENT";
    BorrowBlockReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(BorrowBlockReason || (exports.BorrowBlockReason = BorrowBlockReason = {}));
function borrowBlockReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_BLOCK_REASON':
            return BorrowBlockReason.INVALID_BLOCK_REASON;
        case 1:
        case 'PAST_DUE_PAYMENT':
            return BorrowBlockReason.PAST_DUE_PAYMENT;
        case 2:
        case 'FAILED_REPAYMENT':
            return BorrowBlockReason.FAILED_REPAYMENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return BorrowBlockReason.UNRECOGNIZED;
    }
}
exports.borrowBlockReasonFromJSON = borrowBlockReasonFromJSON;
function borrowBlockReasonToJSON(object) {
    switch (object) {
        case BorrowBlockReason.INVALID_BLOCK_REASON:
            return 'INVALID_BLOCK_REASON';
        case BorrowBlockReason.PAST_DUE_PAYMENT:
            return 'PAST_DUE_PAYMENT';
        case BorrowBlockReason.FAILED_REPAYMENT:
            return 'FAILED_REPAYMENT';
        case BorrowBlockReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.borrowBlockReasonToJSON = borrowBlockReasonToJSON;
//# sourceMappingURL=borrow-block-reason.js.map